import { API, graphqlOperation } from "aws-amplify";
import { localCountServiceOrder } from "libs/idb/service-orders-db";
import { customUserBySub } from "graphql/custom-queries";
import { managedCompaniesByParentID } from "graphql/queries";
import { useOnlineStatus } from "hooks/useOnlineStatus";

import { useState, createContext, useEffect } from "react";

export const LayoutContext = createContext({});

export const LayoutProvider = ({ children, user }) => {
  const online = useOnlineStatus();
  const [layoutState, setLayoutState] = useState({
    sidebarVisible: window.innerWidth > 991.98,
  });
  const [me, setMe] = useState({
    id: "",
    email: user?.attributes?.email,
    sub: user?.username,
    permissions: [],
  });

  const onToggleSidebar = (value) =>
    setLayoutState((prevSt) => ({
      ...prevSt,
      sidebarVisible: value,
    }));

  async function fetchUser() {
    try {
      if (!online) {
        const count = await localCountServiceOrder();
        setMe((prev) => ({
          ...prev,
          id: prev.sub,
          permissions:
            count > 0
              ? [
                  "service-order:read",
                  "service-order:execute",
                  "service-order:read-photo",
                  "service-order:upload-photo",
                  "service-order:delete-photo",
                ]
              : [],
        }));
        return;
      }

      const userData = await API.graphql(
        graphqlOperation(customUserBySub, {
          sub: user.username,
        })
      );
      const userItem = userData.data.userBySub?.items[0];

      if (userItem) {
        let managedCompanies = [];

        if (userItem.companyID) {
          const managedCompaniesData = await API.graphql(
            graphqlOperation(managedCompaniesByParentID, {
              parentID: userItem.companyID,
              filter: { deletedAt: { attributeExists: false } },
            })
          );
          managedCompanies =
            managedCompaniesData.data.managedCompaniesByParentID.items?.map(
              (it) => it.childID
            ) ?? [];
        }

        setMe({
          ...userItem,
          permissions: [
            ...new Set(
              [].concat(
                ...userItem.roles.items?.map((r) =>
                  r.role.permissions.items?.map((perm) => perm.permission.name)
                )
              )
            ),
          ],
          roles: userItem.roles.items?.map((r) => ({
            id: r.role.id,
            name: r.role.name,
          })),
          photoSrc:
            userItem.photoSrc ||
            user.signInUserSession?.idToken?.payload?.picture,
          authProvider:
            user.signInUserSession?.idToken?.payload?.identities?.[0]
              ?.providerName,
          managedCompanies,
        });
      }
    } catch (err) {
      console.log("Fetch User Error:", err);
    }
  }

  useEffect(() => {
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [online]);

  const value = {
    layoutState,
    setLayoutState,
    onToggleSidebar,
    me,
    setMe,
  };

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
};
